"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InformationOmRobotaxi() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="information-om-robotaxi" className="bg-secondary py-24">
      <div className="container mx-auto px-4">
        <div ref={ref} className={`max-w-3xl mx-auto transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-[32px] text-primary text-center mb-10">
            Framtiden för Transport i Sverige
          </h2>

          <div className="space-y-6 font-sans text-[16px] leading-[1.6] text-foreground/80">
            <p>
              Utvecklingen av autonoma fordon går i en rasande fart och omformar i grunden hur vi ser på framtidens mobilitet. Ledande aktörer som <span className="font-medium text-foreground">Tesla</span> med sin <span className="font-medium text-foreground">Full Self-Driving (FSD)</span>-teknik, <span className="font-medium text-foreground">Waymo</span> och <span className="font-medium text-foreground">XPeng</span> driver innovationen framåt genom miljontals testmil och ständigt utvecklade AI-system. Dessa teknologiska genombrott för oss allt närmare en verklighet där självkörande bilar är en naturlig del av stadsbilden.
            </p>
            <p>
              För att denna banbrytande teknik ska kunna rullas ut i stor skala krävs dock omfattande anpassningar av dagens lagstiftning. I Sverige pågår just nu viktiga <span className="font-medium text-foreground">juridiska förändringar</span> och utredningar för att möjliggöra säker testning och framtida kommersiell drift av robotaxis på allmänna vägar. Myndigheter arbetar tätt tillsammans med branschen för att säkerställa att de högsta säkerhetskraven uppfylls, utan att för den sakens skull hämma den tekniska utvecklingen.
            </p>
            <p>
              När de legala ramverken väl är på plats, förväntas introduktionen av robotaxis inte bara minska de totala transportkostnaderna avsevärt, utan också bidra till en radikalt säkrare, mer tillgänglig och utsläppssnål trafikmiljö för alla medborgare.
            </p>
          </div>
        </div>
      </div>
    </section>;
}